<div>
  <app-titlebar #titlebar>
  </app-titlebar>
</div>
<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myOrder label="下單">
    <div class="flex">
      <app-tw-stock-order [stkmbSrv]="stkmbSrv"></app-tw-stock-order>
      <app-future-order></app-future-order>
      <app-sea-future-order></app-sea-future-order>
    </div>
  </mat-tab>
  <mat-tab #myTabGrid label="條件設定">
    <mat-toolbar class="h-9">
      <button mat-flat-button color="primary" class="btn" [class.btn-primary]="true" (click)="doBatch()">
        <mat-icon fontIcon="report"></mat-icon>派班執行
      </button>
      <button color="primary" class="btn" [class.btn-primary]="true" (click)="doBatchNow()">
        <mat-icon fontIcon="report"></mat-icon>立刻執行
      </button>
      <button class="btn" [class.btn-secondary]="true" (click)="doGetPreFilter()">
        <mat-icon fontIcon="history"></mat-icon>取前次
      </button>
    </mat-toolbar>
    <div class="jk-grid-cols-3">
      <div>
        <app-jkcombobox #reportTypeNo label="報表格式" [(value)]="reportType" [items]="reportTypeList"
          [showClearButton]="true">
        </app-jkcombobox>
      </div>
      <div>
        <app-jkdaterange #stkwd002 label="日期" [(valueA)]="pageOpt.date1" [(valueB)]="pageOpt.date2"          [showClearButton]="true"
          [required]="true"
        >
        </app-jkdaterange>
      </div>
    </div>
    <div class="jk-grid-cols-3">
      <div>
        <app-jkbtnedit label="工作人員" [(value)]="pageOpt.uid" maintable="CMSMV" item="W01" valueExpr="MV001"
          displayExpr="MV002" [showClearButton]="true" [showClearButton]="true" id="TD004">
        </app-jkbtnedit>
      </div>
      <div>

      </div>
    </div>
  </mat-tab>
  <mat-tab #myTabResult label="執行結果" >
    <div>
      <app-jktextarea label="PS" [rows]="3" name="comment" id="comment" class="w-full" [required]="true"
        [(value)]="logMessage"  [autoResizeEnabled]="true" [minHeight]="60" [maxHeight]="400"
         >
      </app-jktextarea>
    </div>
</mat-tab>
</mat-tab-group>
